import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        path: "/geophoto",
        name: "SearchMarker",
        component: () => import("./components/SearchMarker.vue"),
        meta: {
            title: "Abaco GeoPhoto",
            navbarItems: [
                {
                    component: "farm-select-nav-bar-item",
                    props: { isRequired: true },
                },
            ],
        },
    },
    {
        name: "marker-detail",
        path: "/geophoto/:marker_id",
        component: () => import("./components/MarkerDetails.vue"),
        meta: {
            navbarItems: [
                {
                    component: "farm-select-nav-bar-item",
                    props: { isRequired: true },
                },
            ],
        },
    },
    // {
    //     path: "/markers/:id",
    //     name: "SearchMarker",
    //     props: true,
    //     component: () => import("./components/SearchMarker.vue")
    // }
];

export default routes;
